import { Link } from "react-router-dom";
import { regions } from "@/mocks/home";

export default function Coverage() {
  return (
    <section className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center">
          <div className="lg:col-span-6">
            <span className="text-xs uppercase tracking-widest text-primary-600 font-semibold">Global reach</span>
            <h2 className="mt-3 text-3xl md:text-5xl font-semibold text-foreground-950 leading-tight">
              1000+ destinations. One rate deck.
            </h2>
            <p className="mt-5 text-foreground-700 leading-relaxed">
              Direct interconnects and premium partner routes across every major region. Search any destination, request live rates, and get a tailored LCR quote within one business day.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row items-stretch gap-2 bg-background-50 border border-background-200 rounded-md p-1.5">
              <div className="flex-1 flex items-center gap-2 px-3">
                <i className="ri-search-line text-foreground-500 w-4 h-4 flex items-center justify-center" />
                <input
                  type="text"
                  placeholder="Search country, prefix or destination (e.g. Brazil Mobile)"
                  className="w-full text-sm bg-transparent outline-none py-2.5 text-foreground-950 placeholder-foreground-500"
                />
              </div>
              <Link
                to="/coverage"
                className="bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-semibold px-5 py-2.5 rounded-md whitespace-nowrap cursor-pointer transition-colors flex items-center justify-center gap-1"
              >
                Check rates
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center" />
              </Link>
            </div>

            <div className="mt-6 flex flex-wrap gap-2">
              {["USA Mobile", "UK Mobile", "Germany Fixed", "Mexico Mobile", "Brazil Mobile", "UAE Mobile", "Nigeria Mobile"].map((t) => (
                <button
                  key={t}
                  type="button"
                  className="text-xs px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-900 hover:bg-secondary-200 cursor-pointer whitespace-nowrap"
                >
                  {t}
                </button>
              ))}
            </div>
          </div>

          <div className="lg:col-span-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {regions.map((r) => (
                <div
                  key={r.name}
                  className="rounded-xl border border-background-200 p-5 bg-background-50 hover:bg-background-100 transition-colors cursor-pointer"
                >
                  <div className="flex items-start justify-between">
                    <span className="w-10 h-10 rounded-lg bg-primary-100 text-primary-700 flex items-center justify-center">
                      <i className={`${r.icon} text-lg w-5 h-5 flex items-center justify-center`} />
                    </span>
                    <span className="text-xs font-medium text-accent-700">{r.destinations}+ dest.</span>
                  </div>
                  <p className="mt-4 text-base font-semibold text-foreground-950 font-heading">{r.name}</p>
                  <p className="text-xs text-foreground-500 mt-1">{r.codes}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}